import React from "react";
import { CheckCircle2 } from "lucide-react";
import { program } from "../mock";

const ProgramCard = ({ card }) => {
  const imageBlock = (
    <div className="overflow-hidden rounded-2xl shadow-xl">
      <img
        src={card.image}
        alt={card.imageAlt}
        className="h-[320px] md:h-[440px] w-full object-cover transition-transform duration-700 hover:scale-105"
      />
    </div>
  );

  const contentBlock = (
    <div>
      <div className="flex items-start gap-4">
        <span className="text-6xl md:text-7xl font-extrabold leading-none text-[#f5c842]">
          {card.number}
        </span>
        <div className="pt-1">
          <h3 className="text-3xl md:text-4xl font-extrabold text-[#16204a]">
            {card.title}
          </h3>
          <p className="mt-2 text-sm font-bold uppercase tracking-[0.14em] text-[#2f52c4]">
            {card.meta}
          </p>
        </div>
      </div>

      <p className="mt-6 text-base leading-relaxed text-[#4a4f63]">
        {card.description}
      </p>

      {card.price && (
        <div className="mt-6 inline-flex flex-col gap-1 rounded-xl border border-[#16204a]/10 bg-white px-5 py-3 shadow-sm">
          <div className="flex items-baseline gap-2">
            <span className="text-xs font-bold uppercase tracking-[0.14em] text-[#4a4f63]">
              Investimento
            </span>
            <span className="text-3xl font-extrabold leading-none text-[#16204a]">
              {card.price}
            </span>
          </div>
          <span className="text-xs font-medium text-[#2f52c4]">
            Valor do exame incluído
          </span>
        </div>
      )}

      {card.bullets.length > 0 && (
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
          {card.bullets.map((b) => (
            <div key={b} className="flex items-start gap-3">
              <CheckCircle2
                size={20}
                className="mt-0.5 flex-shrink-0 text-[#2f52c4]"
                strokeWidth={2.2}
              />
              <span className="text-sm text-[#3a3f52]">{b}</span>
            </div>
          ))}
        </div>
      )}

      {card.requirements && card.requirements.length > 0 && (
        <div className="mt-8 rounded-xl border border-[#16204a]/10 bg-white p-6 shadow-sm">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#2f52c4]">
            Requisitos para inscrição
          </p>
          <ul className="mt-4 space-y-3">
            {card.requirements.map((r) => (
              <li key={r} className="flex items-start gap-3">
                <span className="mt-[7px] h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#16204a]" />
                <span className="text-sm text-[#3a3f52]">{r}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  return (
    <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
      {card.imageSide === "left" ? (
        <>
          {imageBlock}
          {contentBlock}
        </>
      ) : (
        <>
          <div className="order-2 lg:order-1">{contentBlock}</div>
          <div className="order-1 lg:order-2">{imageBlock}</div>
        </>
      )}
    </div>
  );
};

const Program = () => {
  return (
    <section id="programa" className="bg-[#efe9e3] py-20 md:py-28">
      <div className="mx-auto max-w-6xl px-4">
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#2f52c4]">
          {program.label}
        </p>
        <h2 className="mt-4 max-w-2xl text-4xl md:text-5xl font-extrabold leading-tight text-[#16204a]">
          {program.title}
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#4a4f63]">
          {program.description}
        </p>

        {program.cards.map((card) => (
          <ProgramCard key={card.number} card={card} />
        ))}
      </div>
    </section>
  );
};

export default Program;
